export const normalizeDocumentCode = (value: string): string => value.toLowerCase().replace(/[^a-z0-9]/g, '');

export const DOCUMENT_CODE_MIN_QUERY = 2;

export const DOCUMENT_CODE_PAGE_SIZE = 20;

const codeCharPositions = (code: string): number[] => {
    const positions: number[] = [];
    for (let index = 0; index < code.length; index += 1) {
        if (normalizeDocumentCode(code[index]).length > 0) {
            positions.push(index);
        }
    }
    return positions;
};

export const documentCodeMatch = (code: string, query: string): [number, number] | null => {
    const normalizedQuery = normalizeDocumentCode(query);
    if (normalizedQuery.length < DOCUMENT_CODE_MIN_QUERY) return null;

    const at = normalizeDocumentCode(code).indexOf(normalizedQuery);
    if (at === -1) return null;

    const positions = codeCharPositions(code);
    return [positions[at], positions[at + normalizedQuery.length - 1] + 1];
};
